import type { ButtonHTMLAttributes, ComponentType, SVGAttributes } from 'react'

export const ButtonSize = {
  xxs: 'xxs',
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  editor: 'editor',
  inline: 'inline'
} as const

export type ButtonSize = (typeof ButtonSize)[keyof typeof ButtonSize]

export const ButtonColor = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  quaternary: 'quaternary',
  quinary: 'quinary',
  danger: 'danger',
  editorDark: 'editorDark',
  purple: 'purple',
  editor: 'editor'
} as const

export type ButtonColor = (typeof ButtonColor)[keyof typeof ButtonColor]

export const ButtonShape = {
  rounded: 'rounded',
  circle: 'circle'
} as const

export type ButtonShape = (typeof ButtonShape)[keyof typeof ButtonShape]

export type ButtonProps = {
  block?: boolean
  iconOnlyNotSquare?: boolean
  LeadingIcon?: ComponentType<SVGAttributes<SVGElement>>
  leadingIconClassName?: string
  TrailingIcon?: ComponentType<SVGAttributes<SVGElement>> | ComponentType<any>
  trailingIconClassName?: string
  outlined?: boolean
  size?: ButtonSize
  color?: ButtonColor
  shape?: ButtonShape
  loading?: boolean
  isBlurEffect?: boolean
} & ButtonHTMLAttributes<HTMLButtonElement>
